import { TACO0 } from "./TACO0";

export function TACOH() {
    return <div className="v-box">
        <div className='taco-box width-768 height-512 v-box padding-64'>
            <h2 className='font-taco-primary text-black text-24'>Welcome to the <span className="text-taco-pink">OFFICIAL</span> home of Taco Bongo!</h2>
            <div className="v-box">
                <p className='font-taco-primary text-black text-20 padding-8'>
                    Welcome to the OFFICIAL home of Taco Bongo! Hungry? Good. Chillax with the circus freaks and geek out for some suuhhweet dealios.
                    <br /> <br />
                    Don't like tacos? Talk to the paw, mega loser!
                    <br /> <br />
                    Need to find a local franchise? You could always ask the Onion Ring Master for directions.. or you could just... <a href="/tacobongo/findus">Find Us!</a> 
                    <br /> <br />
                    <a href="/tacobongo/sweepstakes">Triple Oaks! The Automobongomobile is heading to you!</a>
                    <br /> <br />
                    <a href="/tacobongo/meetbongo" className='font-taco-primary text-20'>Want to meet Bongo the dog in person??</a>
                </p>
            </div>
        </div>
    </div>
}